import React, { useState, useEffect } from 'react';
import { string, arrayOf as propArrayOf } from 'prop-types';
import classNames from 'classnames';
import { Input } from '@thd-olt-component-react/input';
import { Loader } from '@thd-olt-component-react/loader';
import { Button } from '@thd-olt-component-react/button';
import { Alert } from '@thd-olt-component-react/alert';
import {
  useDataModel,
  params,
  arrayOf,
  string as stringType,
} from '@thd-nucleus/data-sources';
import { track } from '../../analytics';
import '../hdhome-catalog-promo.scss';

const EmailForm = (props) => {

  const [state, setState] = useState({
    isFormSubmissionActive: false,
    successState: false,
    emailValue: '',
    formIsReady: false,
    errorState: false,
    errorValue: ''
  });

  const {
    isFormSubmissionActive,
    successState,
    emailValue,
    formIsReady,
    errorState,
    errorValue
  } = state;

  const { campaignId, subscriptionType } = props;

  const handleEmailChange = (val) => {
    setState((previousState) => {
      return {
        ...previousState,
        emailValue: val,
        errorState: false
      };
    });
  };

  const emailValidation = (text) => {
    const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len
    return emailRE.test(String(text).toLowerCase());
  };

  const options = {
    variables: {
      sourceId: campaignId,
      subscriptionType: subscriptionType.length ? subscriptionType : ['Promotions']
    }
  };

  const [submitEmail, preferencesEmailResponse] = useDataModel('preferencesEmail', options);
  const { responseStatus } = preferencesEmailResponse?.data?.preferencesEmail || {};

  useEffect(() => {
    if (responseStatus === 'Success') {
      setState((previousState) => {
        return {
          ...previousState,
          isFormSubmissionActive: false,
          successState: true
        };
      });
    }
    if (responseStatus === 'Error occurred') {
      setState((previousState) => {
        return {
          ...previousState,
          isFormSubmissionActive: false,
          errorState: true,
          errorValue: responseStatus + ', please try again'
        };
      });
    }
  }, [responseStatus]);

  const submitForm = (evt) => {
    evt.preventDefault();
    if (formIsReady) {
      setState((previousState) => {
        return {
          ...previousState,
          isFormSubmissionActive: true,
          errorState: false,
          successState: false
        };
      });
      track({ event: 'click' });
      submitEmail({
        variables: {
          emailId: emailValue,
        }
      });
    } else {
      setState((previousState) => {
        return {
          ...previousState,
          isFormSubmissionActive: false,
          errorState: true,
          errorValue: 'Please provide your email address, formatted as you@domain.com.'
        };
      });
    }
  };

  const buttonIcon = isFormSubmissionActive ? <Loader active bttn /> : <span>Sign Up</span>;
  const buttonClass = classNames({
    'email-form__button': true,
    'email-form__button--error-message': emailValue !== '',
    'email-form__button--success-message': formIsReady
  });
  return (
    successState ? (
      <Alert
        type="success"
        message="Thanks for signing up. A promo code will arrive in your inbox shortly."
        inline
      />
    ) : (
      <form className="email-form" name="emailPromoBox" onSubmit={submitForm}>
        <span className="email-form__input">
          <Input
            errorText="Enter a valid email"
            header="Enter Your Email:"
            placeholder="yourname@email.com"
            value={emailValue}
            onChange={handleEmailChange}
            onValidate={() => {
              setState((previousState) => {
                return {
                  ...previousState,
                  formIsReady: true
                };
              });
            }}
            onValidationError={() => {
              setState((previousState) => {
                return {
                  ...previousState,
                  formIsReady: false
                };
              });
            }}
            validation={emailValidation}
          />
        </span>
        <span className={buttonClass}>
          <Button>{ buttonIcon }</Button>
        </span>
        { errorState && <span className="email-form__error-message">{errorValue}</span> }
      </form>
    )
  );
};

EmailForm.dataModel = {
  preferencesEmail: params({
    emailId: stringType().isRequired(),
    sourceId: stringType(),
    subscriptionType: arrayOf(stringType())
  }).mutation().shape({
    responseStatus: stringType().isRequired()
  })
};

EmailForm.displayName = 'EmailForm';

EmailForm.propTypes = {
  campaignId: string,
  subscriptionType: propArrayOf(string)
};

EmailForm.defaultProps = {
  campaignId: null,
  subscriptionType: []
};

export { EmailForm };
